import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { updatePOStatus } from './api';
import type { POStatus } from './types';

export function useUpdatePOStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: number; status: POStatus }) => updatePOStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.procurement.purchaseOrders() });
    },
  });
}
